<template>
  <div class="custom-picker ml-12 relative" :style="customStyles">
    <div
      @click="toggleSelect"
      :class="{
        'gray-input': graySelect,
        'delete-border': unwrapped,
        'large-select': large,
        'selected-input': markSelected && chosenOption.length,
        'full-width': fullWidth,
      }"
      class="main-part flex cursor-pointer"
    >
      <p class="picked-option">
        <span>{{ shortOption || defaultValue }}</span>
        <span
          class="additionalLabel ml-1"
          v-if="
            chosenOption &&
            chosenOption[0] &&
            options.find((o) => o.value === chosenOption[0] && o.mainAppUserId)
          "
          >{{ additionalLabel }}</span
        >
        <span v-if="specialChar && !shortOption" class="special-char">{{
          specialChar
        }}</span>
      </p>
      <img
        :class="unwrapped ? 'upside-down' : ''"
        class="ml-2 arrow-icon"
        src="@/icons/down-arrow.png"
        alt=""
      />
    </div>
    <div v-if="errorMsg" class="custom-error-wrapper">
      <span class="custom-error-msg">
        {{ errorMsg }}
      </span>
    </div>
    <div
      v-if="unwrapped"
      class="unfolded-part"
      :class="{
        'gray-unfoldedpart': graySelect,
        'large-unfolded-part': large,
        'full-width': fullWidth,
      }"
    >
      <!-- <div v-if="optionsRef.length<4" class="blank"></div> -->
      <div v-if="isAutocomplete" class="wrapper-radio autocomplete-input">
        <img src="../icons/dod/dodSearchIcon.svg" alt="Search" />
        <input type="text" v-model="autocompleteValue" placeholder="Wyszukaj" />
      </div>
      <div
        @click="newPick(option)"
        :class="
          i === optionsRef.length - 1
            ? 'no-border'
            : graySelect
            ? 'gray-input'
            : ''
        "
        class="wrapper-radio"
        v-for="(option, i) in optionsRef"
        :key="option.value"
      >
        <div
          :class="chosenOption.includes(option.value) ? 'active' : ''"
          class="radio-btn"
        ></div>
        <p
          :class="{
            'active-p': chosenOption.includes(option.value),
            'small-font': smallOptions,
          }"
          style="margin-bottom: 0; height: fit-content"
        >
          {{ option.name }}
          <span class="additionalLabel ml-1" v-if="option.mainAppUserId">{{
            additionalLabel
          }}</span>
        </p>
      </div>
      <!-- <div v-if="optionsRef.length<3" class="blank"></div>
      <div v-if="optionsRef.length<4" class="blank"></div> -->
    </div>
    <div
      v-if="unwrapped"
      class="white-strip"
      :class="{ 'full-width': fullWidth }"
    ></div>
  </div>
</template>
<script>
export default {
  name: "CustomSelect",
  props: [
    "prePick",
    "options",
    "name",
    "defaultValue",
    "specialChar",
    "graySelect",
    "large",
    "isAutocomplete",
    "markSelected",
    "smallOptions",
    "emitWholeObject",
    "fullWidth",
    "customStyles",
    "isMultiple",
    "errorMsg",
    "additionalLabel",
  ],
  emits: ["newPick"],
  data() {
    return {
      unwrapped: false,
      chosenOption: this.prePick
        ? typeof this.prePick === "object"
          ? [...this.prePick]
          : [this.prePick]
        : [],
      optionsRef: [...this.options],
      protected: false,
      autocompleteValue: "",
    };
  },
  mounted() {
    if (
      this.optionsRef[0] &&
      this.optionsRef[0].admin &&
      this.chosenOption === null
    ) {
      this.chosenOption = [window.localStorage.getItem("loggedUser")];
      this.optionsRef.forEach((option) => {
        if (option.name === this.chosenOption[0]) {
          this.$emit("newPick", this.emitWholeObject ? option : option.value);
        }
      });
    }
  },
  watch: {
    chosenSelect() {
      if (this.chosenSelect !== this.name) this.unwrapped = false;
    },
    autocompleteValue() {
      this.optionsRef = this.options.filter((e) =>
        e?.name?.toLowerCase().includes(this.autocompleteValue.toLowerCase())
      );
    },
  },

  methods: {
    newPick(op) {
      if (this.isMultiple) {
        if (this.chosenOption.find((val) => val === op.value))
          this.chosenOption = this.chosenOption.filter(
            (val) => val !== op.value
          );
        else this.chosenOption.push(op.value);
        this.$emit("newPick", this.chosenOption);
      } else {
        this.$emit("newPick", this.emitWholeObject ? op : op.value);
        this.chosenOption = [op.value];
        this.unwrapped = false;
      }
      this.autocompleteValue = "";
      this.optionsRef = [...this.options];
    },
    toggleSelect() {
      this.unwrapped = !this.unwrapped;
      if (this.unwrapped) {
        this.$store.dispatch("setChosenSelectName", this.name);
      }
    },
  },
  computed: {
    chosenSelect() {
      return this.$store.getters.getChosenSelect;
    },
    currentProcess() {
      return this.$store.getters.getCurrentProcess;
    },
    shortOption() {
      let tmp = "";

      this.optionsRef.forEach((option) => {
        if (
          this.chosenOption.includes(option.value) ||
          this.chosenOption.includes(option.name)
        ) {
          if (this.isMultiple) {
            tmp += `${option.shortName}, `;
          } else tmp = option.shortName;
        }
      });
      if (this.isMultiple) {
        tmp = tmp.slice(0, -2);
      }

      return tmp;
    },
  },
};
</script>

<style scoped>
.custom-picker {
  position: relative;
  color: #090741;
}
.flex {
  display: flex;
}
.cursor-pointer {
  cursor: pointer;
}
.main-part {
  border: 1px solid #090741;
  padding: 5px;
  border-radius: 5px;
  width: 140px;
  height: 35px;
  align-items: center;
}
.main-part img {
  width: 18px;
}
.delete-border {
  border-bottom: none;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.unfolded-part {
  position: absolute;
  display: grid;
  place-items: center;
  top: 35px;
  left: -128px;
  content: "";
  width: 273px;
  min-width: fit-content !important;
  max-height: 278px;
  background: #fff;
  border: 1px solid #090741;
  overflow: visible;
  z-index: 999;
  border-radius: 5px;
  border-top-right-radius: 0;
  max-height: 278px;
  overflow-y: auto;
}

.gray-unfoldedpart {
  border: 1px solid #c1c1cf;
  overflow-x: hidden;
}

.large-unfolded-part {
  left: 5px;
  width: calc(100% - 10px);
  border-top: unset;
}

.arrow-icon {
  margin-left: 5px;
  transition: 0.3s all;
}
.upside-down {
  transform: rotate(180deg);
}
.white-strip {
  position: absolute;
  width: 138px;
  height: 3px;
  left: 6px;
  background: #fff;
  top: 35px;
  z-index: 999999;
}
.radio-btn,
.active {
  aspect-ratio: 1 / 1;
  width: 20px;
  height: 20px;
  background: #fff;
  border: 1px solid #aaa9bd;
  margin-top: 3px;
  margin-right: 30px;
  position: relative;
  cursor: pointer;
  border-radius: 999px;
}
.wrapper-radio {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 40px;
  cursor: pointer;
  margin-top: 15px;
  border-bottom: 0.9px solid #090741;
  width: 97%;
}
.no-border {
  border-bottom: none;
}
.radio-btn p {
  font-size: 16px;
  margin-left: 30px;
  margin-bottom: 5px;
  margin-top: -10px;
}
.active {
  border: 1.5px solid #090741;
  font-weight: 700;
  position: relative;
}
.active-p {
  font-weight: 700;
  color: #090741;
}
.active::after {
  content: "";
  position: absolute;
  border-radius: 999px;
  width: 10px;
  height: 10px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  aspect-ratio: 1 / 1;
  background: #ec1a6b;
}
.picked-option {
  width: 90%;
  font-size: 14px;
  margin-block-end: 0;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.blank {
  height: 50px;
}
label {
  display: block;
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 12px;
}
.gray-input {
  border-color: #c1c1cf;
}
.large-select {
  width: 100%;
}
.autocomplete-input {
  border: 1px solid #c1c1cf;
  gap: 10px;
  border-radius: 5px;
  align-items: center;
}
.autocomplete-input input {
  border: unset;
  width: 100%;
  font-size: 16px;
}
.autocomplete-input img {
  width: 24px;
  height: 24px;
}
.selected-input {
  border-color: #0ea754;
}
.small-font {
  font-size: 12px !important;
  margin-bottom: 0;
  line-height: 26px;
}
.full-width {
  width: 100%;
  left: 0px;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: rgb(167, 167, 167);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #090741;
  border-radius: 10px;
}
.additionalLabel {
  color: #e2037e;
}
</style>
